<template>
    <div>
        <LazySudosuFrame />
        <LazyImmersionFrame />
        <LazyTermsAndConditionsPopup v-if="loggedIn" />
        <LazyGDPRPopup v-if="loggedIn" />
        <slot v-if="isLoggedAsAdmin" name="admin-tools">
            <LazyFooterAdminTools />
        </slot>
        <slot />
        <LazyPlatformNotifications v-if="loggedIn" />

        <ClientOnly>
            <LazyHostRedirectionDialog v-if="!loggedIn" />
        </ClientOnly>
        <EnvironnementMarker />
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {
        LazyFooterAdminTools,
        LazyGDPRPopup,
        LazyHostRedirectionDialog,
        LazyImmersionFrame,
        LazyPlatformNotifications,
        LazySudosuFrame,
        LazyTermsAndConditionsPopup,
        EnvironnementMarker,
    } from '#components';
    import {useAsyncData, useAuth, useHasEnoughPriviledge} from '#imports';

    const {data} = await useAsyncData('isAdmin', async () => {
        return {isAdmin: await useHasEnoughPriviledge(['ROLE_ADMIN'])};
    });

    const auth = useAuth();
    const {loggedIn} = storeToRefs(auth);
    const isLoggedAsAdmin = computed(() => loggedIn.value && data.value?.isAdmin);
</script>
